import React, { ReactNode } from 'react';
import {
  ContentListItemStyled,
  ContentListItemWrapper
} from './styles';
import { TextColor, TextCustom, TextLineHeight, TextSize, TextType, TextWeight } from '@vw-marketing/us-components';

interface ContentListItemProps {
  children: ReactNode;
  hyphen?: boolean;
}

const ContentListItem: React.FC<ContentListItemProps> = ({
  children,
  hyphen = true
}) => {
  return (
    <ContentListItemWrapper>
      {hyphen && (
        <TextCustom
          style={{
            fontSize: TextSize.TextSize20,
            lineHeight: TextLineHeight.TextLineHeight32,
            fontWeight: TextWeight.bold,
            fontType: TextType.Headline,
            color: TextColor.secondary
          }}
        >
          —
        </TextCustom>
      )}
      <ContentListItemStyled>
        {children}
      </ContentListItemStyled>
    </ContentListItemWrapper>
  );
};
export default ContentListItem;
